import { render, staticRenderFns } from "./AttachLotsModal.vue?vue&type=template&id=8b2dfab4&scoped=true&"
import script from "./AttachLotsModal.vue?vue&type=script&lang=js&"
export * from "./AttachLotsModal.vue?vue&type=script&lang=js&"
import style0 from "./AttachLotsModal.vue?vue&type=style&index=0&id=8b2dfab4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b2dfab4",
  null
  
)

export default component.exports